module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 17.552 17.301",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#calendar",
      toString: function () {
        return this.url;
      }
    }